// extracted by mini-css-extract-plugin
module.exports = {"faxCard":"FaxViewer_faxCard__1e6xF","faxHeader":"FaxViewer_faxHeader__1T9Ed","faxObject":"FaxViewer_faxObject__sssym"};